import { FirmaDto } from "../../../../../../interfaces/schema";
import { DisplayItem } from "../../../../../formcontrols/DisplayItem";

const FirmaStamMeta2 = ({ firma }: { firma: FirmaDto }) => {
  return (
    <div className="c-card c-item-list">
      <div>
        <DisplayItem label="Kommune" text={firma.kommuneNavigation?.navn} />
      </div>
      <div>
        <DisplayItem
          label="Region"
          text={firma.kommuneNavigation?.regionNrNavigation?.navn}
        />
      </div>
      <div>
        <DisplayItem
          label="Kreds"
          text={firma.retskredsNrNavigation?.advokatkredsNrNavigation?.navn}
        />
      </div>
      <div>
        <DisplayItem
          label="Retskreds"
          text={firma.retskredsNrNavigation?.navn}
        />
      </div>
    </div>
  );
};

export default FirmaStamMeta2;
